import marketplace from 'cfg/marketplace.json';

/**
 * Footer slots that must be present for a ZCS footer response to be considered renderable.
 * Missing any of these makes the footer degraded, so the header/footer cache (RemoteCache)
 * serves the last-good / fallback footer instead.
 *
 * Each list is the subset of slots the marketplace's footer actually ships (i.e. present in its
 * `hfFallBacks/<domain>.fallback.js` footer), so a complete ZCS response never trips detection:
 *  - zappos: copyright, footermenu-1/3/4/5/6, legal-links, sign-up-form, social-links
 *  - 6pm: copyright, footermenu-1..4, legal-links
 *
 * Excluded on purpose:
 *  - Conditionally-rendered slots — `ad` (killswitch), `sign-up-modal` (newly-registered only),
 *    `customer-feedback-survey` — whose absence is expected, not a failure.
 *  - Slots the container reads defensively but the marketplace's footer never ships (e.g. 6pm reads
 *    `social-links` / `footermenu-5`, but neither is in the 6pm footer, and both are render-guarded).
 *    Requiring them would flag every healthy response as degraded.
 */
const REQUIRED_FOOTER_SLOTS_BY_DOMAIN: Record<string, string[]> = {
  '6pm': ['copyright', 'footermenu-1', 'footermenu-2', 'footermenu-3', 'footermenu-4', 'legal-links'],
  'zappos': [
    'copyright',
    'footermenu-1',
    'footermenu-3',
    'footermenu-4',
    'footermenu-5',
    'footermenu-6',
    'legal-links',
    'sign-up-form',
    'social-links'
  ]
};

/** Required footer slots for the current marketplace. Empty for any domain without an entry (no rejection). */
export const REQUIRED_FOOTER_SLOTS: string[] = REQUIRED_FOOTER_SLOTS_BY_DOMAIN[marketplace.domain] || [];

/** The legal/privacy links slot, tracked on its own ops operation (compliance surface). */
export const LEGAL_LINKS_SLOT = 'legal-links';
